export default __webpack_public_path__ + "static/media/wall-6.4defaddb.svg";